export default __webpack_public_path__ + "static/media/logo@3x.77de3dbf.png";